import heroKwiaciarniaImg from '@assets/optimized_home/hero-bouquet-960.webp';
import heroOkazjeImg      from '@assets/optimized_home/category-bukiety-960.webp';
import flowerBoxImg       from '@assets/optimized_home/product-flower-box-premium-960.webp';
import kreatorImg         from '@assets/optimized_home/kreator-background-960.webp';
import heroDostawaImg     from '@assets/optimized_home/category-kompozycje-960.webp';
import type { HeroConfig } from '@/lib/sections/types';
import { isUnavailableBouquetCreatorPath } from '@/lib/storeFeatures';
import heroMobileImg from '@assets/optimized_home/hero-bouquet-480.webp';

import heroAvif from '@assets/optimized_home/hero-bouquet-960.avif';
import heroMobileAvif from '@assets/optimized_home/hero-bouquet-480.avif';

/**
 * Treść Hero strony głównej — serializowalny config sekcji CMS.
 * Obrazy są dziś adresami wygenerowanymi przez bundler; przyszłe API może
 * dostarczyć w tych samych polach publiczne adresy CDN.
 */
export const HERO_CONFIG: HeroConfig = {
  heading: 'Kwiaciarnia internetowa w Lublinie - kwiaty z dostawą',
  lead: 'Wybierz bukiet lub kompozycję dla bliskiej osoby. Zamów online z dostawą pod wskazany adres albo odbiorem w kwiaciarni.',
  slides: [
    {
      id: 1,
      image: heroKwiaciarniaImg,
      imageSrcSet: `${heroMobileImg} 480w, ${heroKwiaciarniaImg} 960w`,
      avifSrcSet: `${heroMobileAvif} 480w, ${heroAvif} 960w`,
      eyebrow: 'Wyraź to, czego nie da się powiedzieć',
      headline: 'Najpiękniejsze chwile\nzaczynają się od kwiatów',
      description: 'Tworzymy wyjątkowe kompozycje, które wyrażają\nwięcej niż słowa.',
      cta: { label: 'Zamów bukiet', href: '/bukiety/' },
      imagePosition: 'center 30%',
    },
    {
      id: 2,
      image: heroOkazjeImg,
      eyebrow: 'Wyjątkowe okazje',
      headline: 'Wyjątkowe bukiety\nna każdą okazję',
      description: 'Urodziny, rocznice, podziękowania -\nwybierz kwiaty pasujące do okazji.',
      cta: { label: 'Zobacz bukiety', href: '/bukiety/' },
      imagePosition: 'center 20%',
    },
    {
      id: 3,
      image: flowerBoxImg,
      eyebrow: 'Elegancja zamknięta w pudełku',
      headline: 'Flower Boxy tworzone\nz dbałością o każdy detal',
      description: 'Kwiaty ułożone w pudełku -\nwybierz formę i kolorystykę prezentu.',
      cta: { label: 'Odkryj Flower Boxy', href: '/flower-boxy/' },
      imagePosition: 'center 25%',
    },
    {
      id: 4,
      image: kreatorImg,
      eyebrow: 'Kreator bukietów',
      headline: 'Stwórz własną kompozycję\ndzięki kreatorowi',
      description: 'Wybierz kwiaty, dodatki i wiadomość -\nstwórz prezent po swojemu.',
      cta: { label: 'Otwórz kreator', href: '/kreatory-bukietow/' },
      imagePosition: 'center 35%',
    },
    {
      id: 5,
      image: heroDostawaImg,
      eyebrow: 'Dostawa pod drzwi',
      headline: 'Kwiaty z dostawą\nw Lublinie i okolicach',
      description: 'Wybierz kompozycję i sprawdź dostępny termin\ndostawy w Lublinie lub okolicach.',
      cta: { label: 'Sprawdź dostawę', href: '/dostawa/' },
      imagePosition: 'center 20%',
    },
  ].filter((slide) => !isUnavailableBouquetCreatorPath(slide.cta.href)),
};
